// extracted by mini-css-extract-plugin
module.exports = {"PageContent":"PageContent--1kRq7"};